import { useEffect, Fragment, useState } from "react";
import { connect } from "react-redux";
import { FormatterMoney } from "components/Function";

const TrackPayout = (data) => {
    const [totalShop, setTotalShop] = useState(0);
    const [countryHold, setCountryHold] = useState(0);
    const [totalCountry, setTotalCountry] = useState(0);
    const [totalHold, setTotalHold] = useState(0);
    const [totalNetEarning, setTotalNetEarning] = useState(0);

    useEffect(() => {
        if (data?.data?.regionSummary?.length > 0) {
            // Tổng shop_count
            const shopSum = data?.data?.regionSummary.reduce(
                (sum, item) => sum + (item.shop_count || 0),
                0
            );

            // Tổng quốc gia có hold_shop_count > 0
            const holdCountries = data?.data?.regionSummary.filter(
                (item) => item.hold_shop_count > 0
            ).length;

            // Tổng số quốc gia trong regionSummary
            const countryCount = data?.data?.regionSummary.length;

            // Tổng hold_amount
            const holdSum = data?.data?.regionSummary.reduce(
                (sum, item) => sum + (FormatterMoney({ money: item.total_hold_amount, currency: item._id, currency_to: "US", type: "number" }) || 0),
                0
            );

            // Tổng net_earning
            const netEarningSum = data?.data?.regionSummary.reduce(
                (sum, item) => sum + (FormatterMoney({ money: item.total_net_earning, currency: item._id, currency_to: "US", type: "number" }) || 0),
                0
            );

            setTotalShop(shopSum);
            setCountryHold(holdCountries);
            setTotalCountry(countryCount);
            setTotalHold(holdSum);
            setTotalNetEarning(netEarningSum);
        }

    }, [data]);

    return (
        <>
            <div className="d-flex align-items-center justify-content-evenly gap-5 mb-5">
                <div className="bg-dark text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8 flex-fill">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Total Hold"}
                        <i className="ki-outline ki-tag fs-3 text-white ms-1 al-vertical-align-middle"></i>
                    </div>
                    <div className="fs-2 fw-bold counted"><FormatterMoney money={totalHold} /></div>
                </div>
                <div className="bg-warning text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8 flex-fill">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Total Net Earning"}
                        <i className="ki-outline ki-dollar fs-3 text-white ms-1 al-vertical-align-middle"></i>
                    </div>
                    <div className="fs-2 fw-bold counted"><FormatterMoney money={totalNetEarning} /></div>
                </div>
                <div className="bg-info text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8 flex-fill">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Total Shop"}
                        <i className="ki-outline ki-shop fs-3 text-white ms-1 al-vertical-align-middle"></i>
                    </div>
                    <div className="fs-2 fw-bold counted">{totalShop}</div>
                </div>
                <div className="bg-danger text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8 flex-fill">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Hold Countries"}
                        <i className="ki-outline ki-color-swatch fs-3 text-white ms-1 al-vertical-align-middle"></i>
                    </div>
                    <div className="fs-2 fw-bold counted">{countryHold}</div>
                </div>
                <div className="bg-primary text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8 flex-fill">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Total Countries"}
                        <i className="ki-outline ki-technology-2 fs-3 text-white ms-1 al-vertical-align-middle"></i>
                    </div>
                    <div className="fs-2 fw-bold counted">{totalCountry}</div>
                </div>
            </div>
            <div className="d-flex gap-2 mb-5">
                <div className="card card-flush py-4  flex-row-fluid">
                    <div className="card-header">
                        <div className="card-title"><h2>Hold by Country</h2></div>
                    </div>
                    <div className="card-body pt-0">
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle table-row-bordered mb-0 fs-6 gy-5 text-gray-600">
                                <tbody>
                                    {data?.data?.regionSummary
                                        ?.filter(region => region.total_hold_amount > 0)
                                        ?.map(region => (
                                            <tr key={region._id}>
                                                <td className="text-bold">
                                                    <div className="d-flex align-items-center text-dark">
                                                        {region._id}
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">
                                                    <div className="d-flex flex-column">
                                                        <span className="text-danger"><FormatterMoney money={region.total_hold_amount} currency={region._id} currency_to={"US"} /></span>
                                                        <span>{region.hold_shop_count} shops</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="card card-flush py-4  flex-row-fluid">
                    <div className="card-header">
                        <div className="card-title"><h2>Shops by Country</h2></div>
                    </div>
                    <div className="card-body pt-0">
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle table-row-bordered mb-0 fs-6 gy-5 text-gray-600">
                                <tbody>
                                    {data?.data?.regionSummary
                                        ?.sort((a, b) => b.shop_count - a.shop_count)
                                        ?.map(region => (
                                            <tr key={region._id}>
                                                <td className="text-bold">
                                                    <div className="d-flex align-items-center text-dark">
                                                        {region._id}
                                                    </div>
                                                </td>
                                                <td className="fw-bold text-end">
                                                    <div className="d-flex flex-column">
                                                        <span>{region.shop_count} shops</span>
                                                        {region.hold_shop_count > 0 ? <span className="text-danger">{region.hold_shop_count} hold</span> : ""}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-flush py-4  flex-row-fluid">
                <div className="card-header">
                    <div className="card-title"><h2>Hold by Status</h2></div>
                </div>
                <div className="card-body pt-0">
                    <div className="d-flex justify-content-around row">
                        {data?.data?.payoutStageDaysGroups
                            ?.sort((a, b) => b.total_hold - a.total_hold)
                            ?.map((stage) => (
                                <div key={stage._id} className="col-12 col-md-6 col-lg-3 shadow al-border-radius-8 mb-3">
                                    <div className="p-2 border border-gray-200 rounded-lg text-center">
                                        <h3 className="text-gray-900 mb-2 mt-2">{stage._id}</h3>
                                        <div className="">
                                            <p className="text-bold text-danger"><b><FormatterMoney money={stage.total_hold} currency={stage.region} currency_to={"US"} /></b></p>
                                            <p className="text-sm text-gray-600">{stage.count} shops</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TrackPayout);
